/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Chevron-right': {
    width: 11,
    height: 16,
    viewBox: '0 0 11 16',
    data: '<path pid="0" d="M1.473 2.368A1.2 1.2 0 013.13.632l6.6 6.3a1.2 1.2 0 010 1.735l-6.6 6.3a1.2 1.2 0 01-1.657-1.736l5.69-5.432-5.69-5.431z" _fill="#00204D" _stroke="#00204D" stroke-width=".6" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
